var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: { "has-return": "", page: _vm.page },
        on: { onReturn: _vm.onReturn }
      }),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "div",
            { staticClass: "erp-search-bar d-flex align-items-center" },
            [
              _c(
                "div",
                { staticClass: "erp-search-bar__field" },
                [
                  _c("custom-drop-down", {
                    attrs: {
                      fieldkey: "id",
                      fieldname: "name",
                      options: _vm.operations,
                      placeholder: "Operación"
                    },
                    model: {
                      value: _vm.filters.operation,
                      callback: function($$v) {
                        _vm.$set(_vm.filters, "operation", $$v)
                      },
                      expression: "filters.operation"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "erp-search-bar__field" },
                [
                  _c("custom-date-range-picker", {
                    model: {
                      value: _vm.dateRange,
                      callback: function($$v) {
                        _vm.dateRange = $$v
                      },
                      expression: "dateRange"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass:
                    "erp-search-bar__field erp-search-bar__field--input"
                },
                [
                  _c("i", {
                    staticClass: "fas fa-search erp-search-bar__icon"
                  }),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.filters.correlationId,
                        expression: "filters.correlationId"
                      }
                    ],
                    staticClass: "form-control erp-search-bar__control",
                    attrs: { placeholder: "Correlation Id", type: "text" },
                    domProps: { value: _vm.filters.correlationId },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.search.apply(null, arguments)
                      },
                      input: function($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.filters,
                          "correlationId",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]
              ),
              _c(
                "div",
                { staticClass: "erp-search-bar__action" },
                [
                  _c(
                    "action-button",
                    {
                      staticClass: "erp-search-bar__btn",
                      attrs: { i: "fas fa-search", variant: "success" },
                      on: { click: _vm.search }
                    },
                    [_vm._v(" Buscar ")]
                  )
                ],
                1
              )
            ]
          )
        ])
      ]),
      _c("custom-title-divider", { attrs: { title: "Resultados" } }),
      _vm.results.length
        ? _c(
            "div",
            { staticClass: "erp-results" },
            [
              _vm._l(_vm.results, function(item) {
                return _c(
                  "div",
                  {
                    key: item.id,
                    staticClass: "mb-3",
                    class: { "erp-item--banner": item.message }
                  },
                  [
                    _c(
                      "callout",
                      {
                        attrs: {
                          "border-color": "celadon",
                          controlled: "",
                          opened: _vm.isExpanded(item.id)
                        },
                        on: {
                          "click:open": function($event) {
                            return _vm.toggleSteps(item.id)
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "row p-3 align-items-center" },
                          [
                            _c("div", { staticClass: "col" }, [
                              _c("span", { staticClass: "data-label" }, [
                                _vm._v("ID:")
                              ]),
                              _c("p", { staticClass: "data mb-0" }, [
                                _vm._v(_vm._s(item.id))
                              ])
                            ]),
                            _c("div", { staticClass: "col" }, [
                              _c("span", { staticClass: "data-label" }, [
                                _vm._v("Correlation ID:")
                              ]),
                              _c("p", { staticClass: "data mb-0" }, [
                                _vm._v(_vm._s(item.correlationId))
                              ])
                            ]),
                            _c("div", { staticClass: "col" }, [
                              _c("span", { staticClass: "data-label" }, [
                                _vm._v("Operación:")
                              ]),
                              _c("p", { staticClass: "data mb-0" }, [
                                _vm._v(_vm._s(item.operationName))
                              ])
                            ]),
                            _c("div", { staticClass: "col" }, [
                              _c("span", { staticClass: "data-label" }, [
                                _vm._v("Inicio:")
                              ]),
                              _c("p", { staticClass: "data mb-0" }, [
                                _vm._v(_vm._s(_vm.formatDate(item.startedAt)))
                              ])
                            ]),
                            _c("div", { staticClass: "col" }, [
                              _c("span", { staticClass: "data-label" }, [
                                _vm._v("Duración:")
                              ]),
                              _c("p", { staticClass: "data mb-0" }, [
                                _vm._v(
                                  _vm._s(_vm.formatDuration(item.durationMs))
                                )
                              ])
                            ]),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-auto d-flex align-items-center"
                              },
                              [
                                _c(
                                  "action-button",
                                  {
                                    attrs: {
                                      i: "fas fa-list-ul",
                                      variant: "outline-success"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.toggleSteps(item.id)
                                      }
                                    }
                                  },
                                  [_vm._v(" Ver Pasos ")]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    ),
                    item.message
                      ? _c("div", { staticClass: "erp-message px-3 py-2" }, [
                          _c("span", { staticClass: "data-label" }, [
                            _vm._v("Mensaje:")
                          ]),
                          _c("span", { staticClass: "data ml-1" }, [
                            _vm._v(_vm._s(item.message))
                          ])
                        ])
                      : _vm._e(),
                    _vm.isExpanded(item.id)
                      ? _c(
                          "div",
                          { staticClass: "erp-steps" },
                          [
                            _vm._m(0, true),
                            _vm.isLoadingSteps(item.id)
                              ? _c("div", { staticClass: "text-center py-3" }, [
                                  _c("em", {
                                    staticClass: "fas fa-spinner fa-spin mr-2"
                                  }),
                                  _vm._v(" Cargando pasos... ")
                                ])
                              : !_vm.stepsFor(item.id).length
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-center py-3 color-secondary-6"
                                  },
                                  [
                                    _vm._v(
                                      " No hay pasos registrados para esta operación. "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._l(_vm.stepsFor(item.id), function(step) {
                              return _c(
                                "div",
                                {
                                  key: step.id,
                                  staticClass: "erp-step",
                                  class: { "is-open": _vm.isStepOpen(step.id) }
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "erp-step__title",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.toggleStep(step.id)
                                        }
                                      }
                                    },
                                    [
                                      _vm._m(1, true),
                                      _c(
                                        "span",
                                        { staticClass: "erp-step__paso" },
                                        [
                                          _vm._v(
                                            "PASO " +
                                              _vm._s(step.stepOrder) +
                                              ":"
                                          )
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "erp-step__name" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.formatStepName(
                                                  step.stepName
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _c(
                                    "transition",
                                    {
                                      attrs: { name: "erp-collapse" },
                                      on: {
                                        "after-enter": _vm.collapseAfterEnter,
                                        "before-enter": _vm.collapseBeforeEnter,
                                        "before-leave": _vm.collapseBeforeLeave,
                                        enter: _vm.collapseEnter,
                                        leave: _vm.collapseLeave
                                      }
                                    },
                                    [
                                      _vm.isStepOpen(step.id)
                                        ? _c(
                                            "div",
                                            { staticClass: "erp-step__body" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "erp-payload" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "erp-payload__head"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "erp-payload__label"
                                                        },
                                                        [
                                                          _c("em", {
                                                            staticClass:
                                                              "fas fa-file-import"
                                                          }),
                                                          _vm._v(
                                                            " Input Payload "
                                                          )
                                                        ]
                                                      ),
                                                      step.inputPayload
                                                        ? _c(
                                                            "action-button",
                                                            {
                                                              staticClass:
                                                                "erp-copy-btn",
                                                              class: {
                                                                "is-copied":
                                                                  _vm.copiedKey ===
                                                                  "in-" +
                                                                    step.id
                                                              },
                                                              attrs: {
                                                                i:
                                                                  _vm.copiedKey ===
                                                                  "in-" +
                                                                    step.id
                                                                    ? "fas fa-check"
                                                                    : "fas fa-copy",
                                                                variant:
                                                                  _vm.copiedKey ===
                                                                  "in-" +
                                                                    step.id
                                                                    ? "success"
                                                                    : "outline-success"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  _vm.copyText(
                                                                    _vm.formatPayload(
                                                                      step.inputPayload
                                                                    ),
                                                                    "in-" +
                                                                      step.id
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.copiedKey ===
                                                                      "in-" +
                                                                        step.id
                                                                      ? "Copiado"
                                                                      : "Copiar"
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  ),
                                                  step.inputPayload
                                                    ? _c("div", {
                                                        staticClass:
                                                          "erp-payload__box",
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.renderCode(
                                                              step.inputPayload
                                                            )
                                                          )
                                                        }
                                                      })
                                                    : _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "erp-payload__empty"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Información no disponible "
                                                          )
                                                        ]
                                                      )
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "erp-payload" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "erp-payload__head"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "erp-payload__label"
                                                        },
                                                        [
                                                          _c("em", {
                                                            staticClass:
                                                              "fas fa-file-export"
                                                          }),
                                                          _vm._v(
                                                            " Output Payload "
                                                          )
                                                        ]
                                                      ),
                                                      step.outputPayload
                                                        ? _c(
                                                            "action-button",
                                                            {
                                                              staticClass:
                                                                "erp-copy-btn",
                                                              class: {
                                                                "is-copied":
                                                                  _vm.copiedKey ===
                                                                  "out-" +
                                                                    step.id
                                                              },
                                                              attrs: {
                                                                i:
                                                                  _vm.copiedKey ===
                                                                  "out-" +
                                                                    step.id
                                                                    ? "fas fa-check"
                                                                    : "fas fa-copy",
                                                                variant:
                                                                  _vm.copiedKey ===
                                                                  "out-" +
                                                                    step.id
                                                                    ? "success"
                                                                    : "outline-success"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  _vm.copyText(
                                                                    _vm.formatPayload(
                                                                      step.outputPayload
                                                                    ),
                                                                    "out-" +
                                                                      step.id
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.copiedKey ===
                                                                      "out-" +
                                                                        step.id
                                                                      ? "Copiado"
                                                                      : "Copiar"
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  ),
                                                  step.outputPayload
                                                    ? _c("div", {
                                                        staticClass:
                                                          "erp-payload__box",
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.renderCode(
                                                              step.outputPayload
                                                            )
                                                          )
                                                        }
                                                      })
                                                    : _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "erp-payload__empty"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " Información no disponible "
                                                          )
                                                        ]
                                                      )
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "row erp-step__footer"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-md-4" },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "data-label"
                                                        },
                                                        [_vm._v("Inicio:")]
                                                      ),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "data mb-0"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.formatDateTime(
                                                                  step.startedAt
                                                                )
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-md-4" },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "data-label"
                                                        },
                                                        [_vm._v("Fin:")]
                                                      ),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "data mb-0"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                step.completedAt
                                                                  ? _vm.formatDateTime(
                                                                      step.completedAt
                                                                    )
                                                                  : "—"
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-md-4" },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "data-label"
                                                        },
                                                        [_vm._v("Duración:")]
                                                      ),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "data mb-0"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.formatSeconds(
                                                                  step.durationMs
                                                                )
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ],
                                1
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e()
                  ],
                  1
                )
              }),
              _vm.showPagination
                ? _c("pagination", {
                    attrs: { data: _vm.pagination },
                    on: { "pagination-go-page": _vm.goToPage }
                  })
                : _vm._e()
            ],
            2
          )
        : _vm.searched && !_vm.fetchFailed
        ? _c("div", { staticClass: "erp-results__empty" }, [
            _vm._v(
              " No se encontraron resultados para los filtros seleccionados. "
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "erp-steps__header" }, [
      _c("span", { staticClass: "erp-steps__badge" }, [
        _c("em", { staticClass: "fas fa-list-ul" })
      ]),
      _c("span", [_vm._v("Pasos de la Operación")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "erp-step__chevron" }, [
      _c("em", { staticClass: "fas fa-chevron-down" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }